import { userAreaNameDtoSchema, userDetailDtoSchema, userDtoSchema } from "@datamole/lssa-api-schema";
import { z } from "zod";

export const userAreaNameSchema = userAreaNameDtoSchema;
export const userDetailSchema = userDetailDtoSchema;
export const usersSchema = z.array(userDtoSchema);
